(() => {
  const root = document.querySelector('[data-faq-page]');
  if (!root) return;

  const finishLoading = () => root.classList.remove('faq-page-content--loading');
  const source = root && root.querySelector('[data-faq-content-source]');
  if (!source) {
    finishLoading();
    return;
  }

  const labels = root.dataset;
  const categories = [];
  const items = [];
  let currentCategory = '';
  let currentItem = null;
  const normalize = (value) => value.trim().toLowerCase();
  const isBlankText = (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '';
  const isBr = (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR';
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  const questionFrom = (element) => {
    if (!element.matches('p')) return '';
    const questionNode = Array.from(element.childNodes).find((node) => !isBlankText(node) && !isBr(node));
    if (!questionNode || questionNode.nodeType !== Node.ELEMENT_NODE || !questionNode.matches('strong, b')) return '';

    const answer = element.cloneNode(false);
    let afterQuestion = false;
    Array.from(element.childNodes).forEach((node) => {
      if (node === questionNode) {
        afterQuestion = true;
        return;
      }
      if (afterQuestion) answer.appendChild(node.cloneNode(true));
    });
    while (answer.firstChild && (isBlankText(answer.firstChild) || isBr(answer.firstChild))) answer.firstChild.remove();
    if (answer.firstChild && answer.firstChild.nodeType === Node.TEXT_NODE) {
      answer.firstChild.textContent = answer.firstChild.textContent.replace(/^\s+/, '');
    }

    return { answer: answer.childNodes.length ? answer : null, question: questionNode.textContent.trim() };
  };

  Array.from(source.children).forEach((element) => {
    if (element.matches('h2, h3, h4, h5, h6')) {
      currentCategory = element.textContent.trim();
      currentItem = null;
      return;
    }
    const question = questionFrom(element);
    if (question) {
      currentItem = { question: question.question, category: currentCategory, answerNodes: [] };
      if (question.answer) currentItem.answerNodes.push(question.answer);
      items.push(currentItem);
      if (currentCategory && !categories.includes(currentCategory)) categories.push(currentCategory);
    } else if (currentItem) currentItem.answerNodes.push(element.cloneNode(true));
  });
  if (!items.length) {
    finishLoading();
    return;
  }

  const container = make('div', 'faq-container');
  const list = make('div', 'collapsible-container');
  if (categories.length) {
    const filter = make('div', 'faq-filter');
    const label = make('label', '', `${labels.faqFilterTitle} `);
    const select = make('select');
    label.htmlFor = 'faq-category-filter';
    select.id = 'faq-category-filter';
    select.appendChild(make('option', '', labels.faqAllCategories));
    select.firstElementChild.value = 'all';
    categories.forEach((category) => {
      const option = make('option', '', category);
      option.value = normalize(category);
      select.appendChild(option);
    });
    filter.append(label, select);
    container.appendChild(filter);
  }

  items.forEach((item, index) => {
    const itemElement = make('div', 'faq-item');
    const button = make('button', 'collapsible');
    const content = make('div', 'content');
    const answer = make('div', 'faq-answer');
    const contentId = `faq-answer-${index + 1}`;
    itemElement.dataset.category = normalize(item.category);
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', contentId);
    button.append(make('b', '', item.question), make('span', 'collapsible-icon', '+'));
    content.id = contentId;
    content.hidden = true;
    content.setAttribute('role', 'region');
    item.answerNodes.forEach((node) => answer.appendChild(node));
    content.appendChild(answer);
    if (item.category) {
      const category = make('p', 'faq-category');
      category.append(`${labels.faqCategoryLabel} `, make('span', '', item.category));
      content.appendChild(category);
    }
    itemElement.append(button, content);
    list.appendChild(itemElement);
  });

  container.appendChild(list);
  root.insertBefore(container, source);
  source.hidden = true;
  root.classList.add('faq-page-content--enhanced');
  finishLoading();
  const buttons = Array.from(root.querySelectorAll('.collapsible'));
  const setOpen = (button, open) => {
    const content = document.getElementById(button.getAttribute('aria-controls'));
    const icon = button.querySelector('.collapsible-icon');
    button.classList.toggle('active', open);
    button.setAttribute('aria-expanded', String(open));
    if (content) content.hidden = !open;
    if (icon) icon.textContent = open ? '-' : '+';
  };
  const closeAll = () => buttons.forEach((button) => setOpen(button, false));
  buttons.forEach((button) => {
    button.addEventListener('click', () => setOpen(button, button.getAttribute('aria-expanded') !== 'true'));
  });

  const filterSelect = root.querySelector('#faq-category-filter');
  const faqItems = Array.from(root.querySelectorAll('.faq-item'));
  const applyFilter = () => {
    const category = filterSelect ? filterSelect.value : 'all';
    closeAll();
    faqItems.forEach((item) => {
      item.hidden = category !== 'all' && item.dataset.category !== category;
    });
  };

  applyFilter();
  if (!filterSelect) return;

  filterSelect.addEventListener('change', applyFilter);
  window.addEventListener('pageshow', () => {
    window.requestAnimationFrame(applyFilter);
  });
})();
